/* eslint-disable no-console */
/* eslint-disable no-async-promise-executor */
import { getRequest, postRequest, deleteRequest, putRequest } from '../config/axios-config';
import { apiRoutes, serverUrl } from '../constants/api-routes';
import { ApiResponse } from '../types/api';
import {
  Comment,
  Notification,
  ContentSubmission,
  ContentSubmissionStage,
  EditContentSubmissionBody,
} from '../types/content-submissions';

const loginCreator = (body: object) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.loginCreator,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const getResources = () =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await getRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.getResources
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const getCreatorDetails = (body: object) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.getCreatorDetails,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const updateInfluencerAddress = (body: object) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.updateInfluencerAddress,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const addInfluencerAddress = (body: object) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.addInfluencerAddress,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const updateDiscountCode = (body: object) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.updateDiscountCode,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const changePassword = (body: object) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.changePassword,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const getLocationDetails = (query: string) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await getRequest(
        `${serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.getLocationDetails}?zipcode=${query}`
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const getPaymentHistory = () =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await getRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.getPaymentHistory
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const getCreatorPendingPayments = () =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await getRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.getCreatorPendingPayments
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const getCreatorCompletedPayments = () =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await getRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.getCreatorCompletedPayments
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const updateCreatorDetails = (profileId: string, body: object) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        `${serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.updateCreatorDetails}/${profileId}`,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const forgotPassword = (body: object) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.forgotPassword,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const resendForgotPasswordEmail = (body: object) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.resendForgotPasswordEmail,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const resetPassword = (body: object, forgotPasswordId: string | undefined, token: string | undefined) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        `${
          serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.forgotPassword
        }/${forgotPasswordId}/${token}`,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const getContentSubmissionPresignedUrl = (fileNames: string[]) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.getContentSubmissionPresignedUrl,
        { fileNames }
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const getContentSubmissions = (stage: ContentSubmissionStage = 'pending') =>
  new Promise<ApiResponse<ContentSubmission[]>>(async (resolve, reject) => {
    try {
      const response = (await getRequest(
        `${serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.getContentSubmissions}?stage=${stage}`
      )) as ApiResponse<ContentSubmission[]>;
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const editContentSubmission = (contentId: string, body: EditContentSubmissionBody) =>
  new Promise<ApiResponse<{ message: string }>>(async (resolve, reject) => {
    try {
      const response = (await putRequest(
        `${serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.editContentSubmission}/${contentId}`,
        body
      )) as ApiResponse<{ message: string }>;
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const deleteContentSubmission = (contentId: string) =>
  new Promise<ApiResponse<{ message: string }>>(async (resolve, reject) => {
    try {
      const response = (await deleteRequest(
        `${serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.deleteContentSubmission}/${contentId}`
      )) as ApiResponse<{ message: string }>;
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const getContentComments = (contentId: string) =>
  new Promise<ApiResponse<Comment[]>>(async (resolve, reject) => {
    try {
      const response = (await getRequest(
        `${serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.getContentComments}/${contentId}`
      )) as ApiResponse<Comment[]>;
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const getNotifications = () =>
  new Promise<ApiResponse<Notification[]>>(async (resolve, reject) => {
    try {
      const response = (await getRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.getNotifications
      )) as ApiResponse<Notification[]>;
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const updateNotificationStatus = (body: object) =>
  new Promise<ApiResponse<{ message: string }>>(async (resolve, reject) => {
    try {
      const response = (await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.updateNotificationStatus,
        body
      )) as ApiResponse<{ message: string }>;
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const createContentSubmission = (body: {
  type: 'media' | 'link';
  name: string;
  keys: { key: string; type: string }[] | null;
  link: string | null;
}) =>
  new Promise<ApiResponse<{ message: string }>>(async (resolve, reject) => {
    try {
      const response = (await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.getContentSubmissions,
        body
      )) as ApiResponse<{ message: string }>;
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const getCreatorCompletedPaymentsForUGCCreators = () =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await getRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.getCreatorCompletedPaymentsForUGCCreators
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const getProductRequestSettings = () =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await getRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.getProductRequestSettings
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const createProductRequest = (body: object) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.createProductRequest,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const getProductsListInfo = (body: object) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await postRequest(
        serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.getProductsListInfo,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const getProducts = (query: string) =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await getRequest(
        `${serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.getProducts}?title=${query}`
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

const getProductRequestedByCreator = () =>
  new Promise<any>(async (resolve, reject) => {
    try {
      const response = await getRequest(
        `${serverUrl + import.meta.env.VITE_APP_DASHBOARD_SERVER_PORT + apiRoutes.getProductRequestedByCreator}`
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });

export {
  addInfluencerAddress,
  changePassword,
  deleteContentSubmission,
  editContentSubmission,
  forgotPassword,
  getContentComments,
  getContentSubmissionPresignedUrl,
  getContentSubmissions,
  getCreatorCompletedPayments,
  getCreatorDetails,
  getCreatorPendingPayments,
  getLocationDetails,
  getNotifications,
  getPaymentHistory,
  getResources,
  loginCreator,
  resendForgotPasswordEmail,
  resetPassword,
  updateCreatorDetails,
  updateDiscountCode,
  updateInfluencerAddress,
  updateNotificationStatus,
  createContentSubmission,
  getCreatorCompletedPaymentsForUGCCreators,
  getProductRequestSettings,
  getProductsListInfo,
  createProductRequest,
  getProducts,
  getProductRequestedByCreator,
};
